export function getWorkloadInISO(workload: string): string {
  if (!workload) return "PT32H"; // Default to 32 hours if no workload is provided

  const str = workload.trim().toLowerCase();

  // Match number + unit (e.g. "2 days", "32 hrs", "4 weeks")
  const match = str.match(
    /(\d+)\s*(day|days|d|hour|hours|hrs|h|week|weeks|w|month|months|m|year|years|y)/
  );

  if (!match) return "PT32H"; // Default to 32 hours if no workload is provided

  const valueStr = match[1];
  const unit = match[2];

  if (valueStr === undefined || unit === undefined) return "PT32H";

  const value = parseInt(valueStr, 10);
  switch (true) {
    case /day|d/.test(unit):
      return `P${value}D`; // Period in Days
    case /hour|hrs|h/.test(unit):
      return `PT${value}H`; // Time in Hours
    case /week|w/.test(unit):
      return `P${value}W`; // Period in Weeks
    case /month|m/.test(unit):
      return `P${value}M`; // Period in Months
    case /year|y/.test(unit):
      return `P${value}Y`; // Period in Years
    default:
      return "PT32H"; // Default to 32 hours if no workload is provided
  }
}
